import { useEffect, useState, useCallback } from "react";
import { supabase } from "../supabaseClient";

export default function useInfiniteSupabase({
  table,
  select = "*",
  pageSize = 25,
  searchTerm,
  searchColumns = [],
  orderBy = "id",
}) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // main fetch
  const fetchData = useCallback(
    async (currentPage, isReset = false) => {
      if (loading) return;

      setLoading(true);

      let query = supabase
        .from(table)
        .select(select)
        .order(orderBy, { ascending: true })
        .range(
          currentPage * pageSize,
          (currentPage + 1) * pageSize - 1
        );

      if (searchTerm?.trim() && searchColumns.length) {
        const orQuery = searchColumns
          .map((col) => `${col}.ilike.%${searchTerm}%`)
          .join(",");
        query = query.or(orQuery);
      }

      const { data: newData, error } = await query;

      if (!error) {
        setData((prev) =>
          isReset ? newData || [] : [...prev, ...(newData || [])]
        );

        setHasMore(newData?.length === pageSize);
      }

      setLoading(false);
    },
    [searchTerm, table, select, orderBy, pageSize, searchColumns, loading]
  );

  // ✅ RESET + FORCE FETCH
  useEffect(() => {
    setPage(0);
    setHasMore(true);
    fetchData(0, true); // 🔥 force fresh fetch always
  }, [searchTerm]);

  // ✅ load more
  useEffect(() => {
    if (page === 0) return; // already handled above
    fetchData(page);
  }, [page]);

  return {
    data,
    setData, 
    loading,
    hasMore,
    loadMore: () => {
      if (!loading && hasMore) {
        setPage((p) => p + 1);
      }
    },
    reset: () => {
  setPage(0);
  setHasMore(true);
  fetchData(0, true);
}
  };
}